import { Model } from 'dva';

const initialModalsState = {
  addChildModalOpen: false,
  childrenModalOpen: false,
  errorSubmitModalOpen: false,
};

export const addChildModalOpen = (open: boolean) => ({
  type: 'modals/toggle',
  payload: {
    name: 'addChildModalOpen',
    open,
  },
});

export const childrenModalOpen = (open: boolean) => ({
  type: 'modals/toggle',
  payload: {
    name: 'childrenModalOpen',
    open,
  },
});

export const errorSubmitModalOpen = (open: boolean) => ({
  type: 'modals/toggle',
  payload: {
    name: 'errorSubmitModalOpen',
    open,
  },
});

const modalsModel: Model = {
  namespace: 'modals',
  state: initialModalsState,
  reducers: {
    toggle(state, { payload }) {
      const { name, open } = payload;
      state[name] = open;
      return state;
    },
  },
  effects: {
    *toggle({ payload }, { put, select }) {
      const { name } = payload;
      const isChildrenListModal = payload.open && name === 'childrenModalOpen';
      if (!isChildrenListModal) return;
      yield put({
        type: 'child/reset',
      });
      const hasUnAddedChildren = yield select((state) => {
        return Object.values(state.children).some(({ hidden }) => hidden);
      });
      if (!hasUnAddedChildren) {
        yield put(childrenModalOpen(false));
        yield put(addChildModalOpen(true));
      }
    },
  },
};

export default modalsModel;
